module.exports = __webpack_public_path__ + "static/media/shapes_05.c29afb60.svg";